import { render } from "./InstructionDialog.vue?vue&type=template&id=0470566a"
import script from "./InstructionDialog.vue?vue&type=script&lang=js"
export * from "./InstructionDialog.vue?vue&type=script&lang=js"

import "./InstructionDialog.vue?vue&type=style&index=0&id=0470566a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__